import React from 'react';
import { DefaultIconProps } from '@gamiphy/icons/types';

const GiftIcon: React.FC<DefaultIconProps> = ({
  className, width, height, textColor = '#fff',
}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={className} viewBox="0 0 22 22">
    <g data-name="Grupo 140547">
      <path d="M0 0h24v24H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
      <path d="M6.5 2h11a1 1 0 0 1 .8.4L21 6v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4zM19 8H5v12h14zm-.5-2L17 4H7L5.5 6z" fill={textColor} />
      <g data-name="shopping-bag-3-line" opacity="0.5">
        <path data-name="Path" d="M0 0h24v24H0z" style={{ fill: 'none', fillRule: 'evenodd' }} />
        <path data-name="Shape" d="M6.5 2h11a1 1 0 0 1 .8.4L21 6v15a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6l2.7-3.6a1 1 0 0 1 .8-.4zM19 8H5v12h14zm-.5-2L17 4H7L5.5 6zM9 10v2a3 3 0 1 0 6 0v-2h2v2a5 5 0 1 1-10 0v-2z" fill={textColor} />
      </g>
    </g>
  </svg>

);

export default GiftIcon;
